import { InputNumber, InputNumberProps } from 'antd';
import { FC, memo, useEffect, useState } from 'react';

export const InputTable: FC<InputNumberProps> = memo(({ value, ...rest }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  const onChange: InputNumberProps['onChange'] = (newValue) => {
    setLocalValue(newValue);
  };

  return <InputNumber {...rest} onChange={onChange} value={localValue} />;
});
